import { render, staticRenderFns } from "./DocumentationView.vue?vue&type=template&id=4697f3fc"
import script from "./DocumentationView.vue?vue&type=script&lang=js"
export * from "./DocumentationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports